import { Result, Row } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './ProjectEditPageContent.module.scss'
import { projectDetailsSelector, setFormDataValues } from 'src/features'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { ProjectFormStepSlider, ProjectForm, CustomCard, PageTitle, CustomCol, AccountBreadcrumb } from 'src/components'

const ProjectEditPageContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { width } = useWindowSize()
  const isMobile = width < 800
  const { loading, project } = useAppSelector(projectDetailsSelector)
  const isErrorOnLoading = !loading && !project

  useEffect(() => {
    if (project) { dispatch(setFormDataValues(project)) }
  }, [dispatch, project])

  return (
    <div className='fade-animation'>
      <Row className={styles.contentMargin}>
        <CustomCol className={isMobile && styles.mobileView}>
          <PageTitle>
            <div className={styles.breadcrumbContent}>
              <AccountBreadcrumb
                homeLink='/my-projects'
                beforeLink={`/my-projects/details?id=${project?.id}`}
                secondLabel={t('Projects.Details.Title')}
                thirdLabel={t('Projects.EditProject')}
              />
            </div>
          </PageTitle>
        </CustomCol>
        <CustomCol>
          <div className='float-right'>
            <ProjectFormStepSlider />
          </div>
        </CustomCol>
      </Row>

      <CustomCard loading={loading} className={styles.contentMargin}>
        {isErrorOnLoading ? (
          <Result title={t('Projects.Details.ErrorLoading')} />
        ) : project && <ProjectForm />
        }
      </CustomCard>
    </div>
  )
}


export default ProjectEditPageContent
